const Constant = {
   // PROXY_URL: 'https://cors-anywhere.herokuapp.com/',
   PROXY_URL: '',
   // URL: 'http://197.243.1.50:20907',
   // URL: 'http://197.243.1.50:20914',
   URL: 'http://41.186.24.68:20909/api'
   // URL: 'http://10.169.2.152:20800'
};

export const xmlHistoryData =
   "<?xml version='1.0' encoding='UTF-8'?><vendinghistoryresponse><responsecode>1</responsecode><responsedesc>SUCCESSFUL</responsedesc><referenceid>VA15986125212111102</referenceid><transactionid>KA1598612477033554</transactionid><sales><salerecord><transactionid>KA1598449269001956</transactionid><buyeridentifier>14235760049</buyeridentifier><amount>100.0</amount><mobilenumber>738495393</mobilenumber><status>SALE COMPLETED</status><datetime>2020-08-26 15:41:10</datetime><product>Electricity</product></salerecord><salerecord><transactionid>KA1598585510273476</transactionid><buyeridentifier></buyeridentifier><amount>100.0</amount><mobilenumber>0</mobilenumber><status>TOKEN CANNOT BE GENERATED</status><datetime>2020-08-28 05:31:50</datetime><product>Electricity</product></salerecord><salerecord><transactionid>KA1598585544538378</transactionid><buyeridentifier></buyeridentifier><amount>100.0</amount><mobilenumber>0</mobilenumber><status>TOKEN CANNOT BE GENERATED</status><datetime>2020-08-28 05:32:24</datetime><product>Electricity</product></salerecord><salerecord><transactionid>KA1598585680121675</transactionid><buyeridentifier></buyeridentifier><amount>100.0</amount><mobilenumber>0</mobilenumber><status>TOKEN CANNOT BE GENERATED</status><datetime>2020-08-28 05:34:40</datetime><product>Electricity</product></salerecord><salerecord><transactionid>KA1598585698378073</transactionid><buyeridentifier></buyeridentifier><amount>100.0</amount><mobilenumber>0</mobilenumber><status>TOKEN CANNOT BE GENERATED</status><datetime>2020-08-28 05:34:58</datetime><product>Electricity</product></salerecord><salerecord><transactionid>KA1598585762588613</transactionid><buyeridentifier></buyeridentifier><amount>100.0</amount><mobilenumber>0</mobilenumber><status>TOKEN CANNOT BE GENERATED</status><datetime>2020-08-28 05:36:02</datetime><product>Electricity</product></salerecord></sales></vendinghistoryresponse>";

export const xmlReceipt =
   "<?xml version='1.0' encoding='UTF-8'?><vendingreceiptdetailsresponse><responsecode>1</responsecode><responsedesc>SUCCESSFUL</responsedesc><referenceid>ACB1597073438</referenceid><transactionid>KA1601271282702128</transactionid><receiptrecord><transactionid></transactionid><firstname>GEOFREY BYEGEKA</firstname><lastname></lastname><meternumber>14235760049</meternumber><purchaseamount>100</purchaseamount><receiptnumber>2212/2902056</receiptnumber><tariffname>Residential_Seq</tariffname><tariffinfo>@ 249.0/kWh</tariffinfo><token>0694-2521-8155-9103-2398</token><units>0.4</units><datetime>2020-09-10 13:34:15</datetime><mobilenumber></mobilenumber><productname>Electricity</productname><receiptitems><item><desc>Residential_Seq @ 249.0/kWh</desc><value>84.493</value></item><item><desc>Regulatory. fees @ 0.3%</desc><value>0.253</value></item><item><desc>TVA @ 18.0%</desc><value>15.254</value></item></receiptitems></receiptrecord></vendingreceiptdetailsresponse>";

export const sampleHistory = [
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-10 13:24:18',
      mobilenumber: '789895757',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599737056019545',
   },
   {
      amount: '100.0',
      buyeridentifier: '01318787213',
      datetime: '2020-09-10 13:23:32',
      mobilenumber: '789895757',
      product: 'Electricity',
      status: 'TOKEN CANNOT BE GENERATED',
      transactionid: 'KA1599737012626988',
   },
   {
      amount: '100.0',
      buyeridentifier: '01318787213',
      datetime: '2020-09-03 09:48:54',
      mobilenumber: '789895757',
      product: 'Electricity',
      status: 'TOKEN CANNOT BE GENERATED',
      transactionid: 'KA1599119333872676',
   },
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-03 07:19:49',
      mobilenumber: '789895757',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599110387110184',
   },
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-03 07:16:16',
      mobilenumber: '789895757',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599110175035946',
   },
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-03 07:12:17',
      mobilenumber: '738495393',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599109935826479',
   },
   {
      amount: '100.0',
      buyeridentifier: '14102670545',
      datetime: '2020-09-03 07:09:05',
      mobilenumber: '738495393',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599109743658098',
   },
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-03 07:06:36',
      mobilenumber: '738495393',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599109594743674',
   },
   {
      amount: '100.0',
      buyeridentifier: '14235760049',
      datetime: '2020-09-02 16:41:08',
      mobilenumber: '738495393',
      product: 'Electricity',
      status: 'SALE COMPLETED',
      transactionid: 'KA1599057666436624',
   },
];

export const fixedVendingResponse = {
   firstName: 'GEOFREY BYEGEKA',
   lastName: '',
   meterNumber: '14235760049',
   purchaseAmount: 100,
   receipt: '2212/2649939',
   referenceId: 'VA15990223801951102',
   responseCode: 1,
   responseDesc: 'SUCCESSFUL',
   tariffInfo: '@ 89.0/kWh',
   tarrifName: 'Residential_Seq ',
   token: '0297-0254-5508-5871-8792',
   transactionId: 'KA1599022409124699',
   units: 1,
};

export default Constant;
